import { render, staticRenderFns } from "./ProfileAchievements.vue?vue&type=template&id=0ec30bb3&scoped=true"
import script from "./ProfileAchievements.vue?vue&type=script&lang=ts"
export * from "./ProfileAchievements.vue?vue&type=script&lang=ts"
import style0 from "./ProfileAchievements.vue?vue&type=style&index=0&id=0ec30bb3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec30bb3",
  null
  
)

export default component.exports